export default __webpack_public_path__ + "static/media/ky.a1897118.svg";